export default {"src":"/_next/static/media/sort.c0344c21.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};